import type { LocaleCode } from "@/lib/labels/types";

export type WidgetLanguage =
    | "bg"
    | "en"
    | "ro"
    | "pt"
    | "sr"
    | "fr"
    | "de"
    | "it"
    | "fr-be"
    | "pl"
    | "pt-br"
    | "sk";

const localeToWidgetLanguage: Partial<Record<LocaleCode, WidgetLanguage>> = {
    "pt-BR": "pt-br",
};

export function getWidgetLanguage(locale: LocaleCode): WidgetLanguage {
    return localeToWidgetLanguage[locale] ?? (locale as WidgetLanguage);
}
